module.exports = __webpack_public_path__ + "static/media/logo2.a92a6750.png";